module.exports = "<table class=\"table table-bordered table-sm  text-center\">\r\n\r\n  <thead class=\"thead-light\">\r\n    <tr>\r\n      <th>N&uacute;mero</th>\r\n      <th>Ramal</th>\r\n      <th>Tipo</th>\r\n      <th>Editar</th>\r\n      <th>Remover</th>\r\n    </tr>\r\n  </thead>\r\n\r\n  <ng-content></ng-content>\r\n\r\n</table>"


//////////////////
// WEBPACK FOOTER
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/components/telefone/telefone.component.html
// module id = ../../../../../src/app/comum/components/telefone/telefone.component.html
// module chunks = main